import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import AngleRightIcon from '../../icons/AngleRightIcon';
import FolderIcon from '../../icons/FolderIcon';
import { folderHasChildrenByTotals } from '../../../util/album-folder';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  basePath: PropTypes.string,
};

const AlbumFolderItem = ({ albumFolder, basePath }) => {
  if (!folderHasChildrenByTotals(albumFolder)) {
    return null;
  }

  return (
    <Link
      to={`${basePath}/${albumFolder.id}/select`}
      className="discover-album-folder-container"
    >
      <FolderIcon color="#0d84fe" size={18} className="mr-2" />

      <span className="mr-1">{albumFolder.name}</span>

      <AngleRightIcon color="#0d84fe" className="ml-auto" height="18" />
    </Link>
  );
};

AlbumFolderItem.propTypes = propTypes;

export default AlbumFolderItem;
